import React, { ReactNode } from 'react';
import { Drawer, DrawerProps } from '@mui/material';

export interface CommonDrawerProps extends Omit<DrawerProps, 'open' | 'onClose'> {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  backgroundColor?: string;
  fullHeight?: boolean;
}

const CommonDrawer: React.FC<CommonDrawerProps> = ({
  open,
  onClose,
  children,
  backgroundColor = '#FFFFFF',
  fullHeight = false,
  className,
  ...props
}) => {
  return (
    <Drawer
      className={className}
      anchor="right"
      open={open}
      onClose={onClose}
      variant="persistent"
      PaperProps={{
        sx: {
          width: 560,
          minWidth: 560,
          maxWidth: 560,
          backgroundColor: backgroundColor,
          height: fullHeight ? '100vh' : 'calc(100vh - 76px)',
          top: fullHeight ? 0 : '76px',
          overflowY: 'auto',
          boxShadow: '-2px 4px 8px rgba(0, 0, 0, 0.1)',
        }
      }}
      ModalProps={{
        BackdropProps: {
          sx: {
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
          }
        }
      }}
      {...props}
    >
      {children}
    </Drawer>
  );
};

export default CommonDrawer;
